import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {LoopAbleList} from "../../core/utils/LoopAbleList";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";

export class WalkOfShameSound {
    public static AS_WIN:string="asWin";
    public static AS_WIN_BIG:string="asWinBig";

    public static MAIN_GAME_MUSIC: string = "background-music-main";
    public static WALK_OF_SHAME_LOOP: string = "walkOfShameLoop";
    public static FS_MAIN: string = "fsMain";
    public static FS_SUPER: string = "fsSuper";
    public static FS_OUTRO_NO_WIN: string = "fsOutroNoWin";
    public static FS_OUTRO_WIN: string = "fsOutroWin";

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: LoopAbleList<string> = new LoopAbleList(["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"]).setRandomizeAtWrapAround(true);
    public static COUNT_UP: string = "countup";
    public static COUNT_UP_END_TINY: string = "countupEndTiny";
    public static COUNT_UP_END_SMALL: string = "countupEndSmall";
    public static COUNT_UP_END_MEDIUM: string = "countupEndMid";
    public static COUNT_UP_END_LARGE: string = "countupEndLarge";
    public static BIG_WIN: string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];
    public static BIG_WIN_END: string = "bigwinEnd";
    public static FS_END: string = "fsEnd";
    public static WILD_LAND: string = "wildLand";
    public static WILD_TRANSFORM: string = "wildTransform";
    public static WALK_OF_SHAME_START: string = "walkOfShameStart";
    public static WILD_WALKING_START: string[] = ["wildWalkingStart01", "wildWalkingStart02", "wildWalkingStart01"];
    public static WILD_WALKING: string[] = ["wildWalking01", "wildWalking02", "wildWalking03"];
    public static WILD_WALKING_M1: string[] = ["wildWalkingM101", "wildWalkingM102", "wildWalkingM103"];
    public static WILD_WALKING_M2: string[] = ["wildWalkingM201", "wildWalkingM202", "wildWalkingM203"];
    public static WILD_WALKING_M3: string[] = ["wildWalkingM301", "wildWalkingM302", "wildWalkingM303"];
    public static WILD_WALKING_M4: string[] = ["wildWalkingM401", "wildWalkingM402", "wildWalkingM403"];
    public static WALK_OF_SHAME_END: string = "walkOfShameEnd";
    public static S2_LAND: string = "s2Land";
    public static S2_LAND_FS: string = "s2LandFS";
    public static S1_LAND: string[] = ["s1Land1", "s1Land2", "s1Land3", "s1Land4"];
    public static S1_LAND_FS: string = "s1LandFS";
    public static S_ANTICIPATION: string = "sAnticipation";
    public static S_ANTICIPATION_FAIL: string = "sAnticipationFail";
    public static S_ANTICIPATION_SUCCESS: string = "sAnticipationSuccess";
    public static S1_POP_UP: string = "s1PopUp";
    public static FS_INTRO: string = "fsIntro";
    public static FS_CONTINUE: string = "fsContinue";
    public static X_SPLIT_LIGHTER_SPARK: LoopAbleList<string> = new LoopAbleList<string>(["xSplitLighterSpark01", "xSplitLighterSpark02", "xSplitLighterSpark03"]).setRandomizeAtWrapAround(true);
    public static X_SPLIT_NO_WIN: LoopAbleList<string> = new LoopAbleList<string>(["xSplitNoWin01", "xSplitNoWin02", "xSplitNoWin03"]).setRandomizeAtWrapAround(true);
    public static X_SPLIT_WIN: LoopAbleList<string> = new LoopAbleList<string>(["xSplitWin01", "xSplitWin02", "xSplitWin03"]).setRandomizeAtWrapAround(true);
    public static X_SPLIT_LIGHTER_ON: string = "xSplitLighterOn";
    public static X_SPLIT_LIGHTER_OFF: string = "xSplitLighterOff";
    public static MULTIPLIER_WOOSH: LoopAbleList<string> = new LoopAbleList<string>(["multiplierWoosh01", "multiplierWoosh02", "multiplierWoosh03"]).setRandomizeAtWrapAround(true);
    public static MULTIPLIER_UP: LoopAbleList<string> = new LoopAbleList<string>(["multiplierUp01", "multiplierUp02", "multiplierUp03"]).setRandomizeAtWrapAround(true);
    public static MULTIPLIER_COUNT_UP: LoopAbleList<string> = new LoopAbleList<string>(["multiplierCountup01", "multiplierCountup02", "multiplierCountup03"]).setRandomizeAtWrapAround(true);
    public static FS_END_SUPER: string = "fsEndSuper";
    public static BIG_WIN_INTRO: string = "bigwinIntro";
    public static WAYS_TICK: string = "waysTick";
    public static PARACHUTE: string = "parachute";
    public static PARACHUTE_PT: LoopAbleList<string> = new LoopAbleList<string>(["parachutePT01", "parachutePT02", "parachutePT03"]).setRandomizeAtWrapAround(true);
    public static PARACHUTE_SK: LoopAbleList<string> = new LoopAbleList<string>(["parachuteSK01", "parachuteSK02", "parachuteSK03"]).setRandomizeAtWrapAround(true);
    public static CLICK_DRAGON: string = "clickDragon";
    public static CLICK_GUN: LoopAbleList<string> = new LoopAbleList<string>(["clickGun01", "clickGun02", "clickGun03"]).setRandomizeAtWrapAround(true);
    public static CLICK_HAT: LoopAbleList<string> = new LoopAbleList<string>(["clickHat01", "clickHat02", "clickHat03"]).setRandomizeAtWrapAround(true);
    public static CLICK_SHEEP: string = "clickSheep";
    public static CLICK_TAPE: LoopAbleList<string> = new LoopAbleList<string>(["clickTape01", "clickTape02", "clickTape03"]).setRandomizeAtWrapAround(true);
    public static CLICK_WHIP: string = "clickWhip";
    public static CAP_WIN_COUNT_UP: string = "capwinCountup";
    public static CAP_WIN_LOOP: string = "capwinLoop";
    public static CAP_WIN_END: string = "capwinEnd";
    public static WIN_SWEEP_SYM: string = "winSweepSym";
    public static WIN_SWEEP_WILD: string = "winSweepWild";
    public static SFS_CAR: string = "sfsCar";

    private static _davidPanningReelStop: number[] = [-0.25, -0.18, 0.01, 0.18, 0.25];
    private static _prevReelStopSound: string = "";

    constructor() {
        WalkOfShameSound.soundPlayer.showLogs(true);
    }

    private static _currentMusic: string = "";

    static set currentMusic(value: string) {
        this._currentMusic = value;
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>WalkOfShame.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf, canStop: boolean = true): void {
        if (conf.name === WalkOfShameSound._currentMusic) {
            return;
        }

        if (WalkOfShameSound._currentMusic != null) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade: NolimitHowl | undefined = this.soundPlayer.fadeTrack(fadeOutConf),
                    fadeName: string = this._currentMusic;

                if (canStop) {
                    if (fade) {
                        gsap.to(this, {
                            duration: fadeOutConf.duration / 1000,
                            onComplete: () => {
                                this.soundPlayer.stopTrack(fadeName);
                            }
                        });
                    } else {
                        this.soundPlayer.stopTrack(fadeName);
                    }
                }
            } else {
                this.soundPlayer.stopTrack(WalkOfShameSound._currentMusic);
            }
        }

        this.soundPlayer.playTrack(conf);
        if (fadeInConf) {
            this.soundPlayer.fadeTrack(fadeInConf);
        }
        WalkOfShameSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol: number, duration: number): void {
        this.soundPlayer.fadeTrack({
            name: WalkOfShameSound._currentMusic,
            to: vol,
            duration: duration
        });
    }

    public static getMusicNameByMode(mode: WalkOfShameGameMode): string {
        switch (mode) {
            case WalkOfShameGameMode.FREESPIN:
                return WalkOfShameSound.FS_MAIN;
            case WalkOfShameGameMode.SUPER_FREESPIN:
                return WalkOfShameSound.FS_SUPER;
            case WalkOfShameGameMode.RESPIN:
            case WalkOfShameGameMode.SUPER_FREESPIN_RESPIN:
                return WalkOfShameSound.WALK_OF_SHAME_LOOP;
            default:
                return WalkOfShameSound.MAIN_GAME_MUSIC;
        }
    }

    public static fadeAndStopSound(fadeOutConf: IFadeTrackConf): void {
        const fade = this.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    this.soundPlayer.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            this.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    // #118
    public static playRandomReelStopSound(reelId: number): void {
        let soundName: string = WalkOfShameSound.REELS_LANDING.next();

        while (soundName === this._prevReelStopSound) {
            soundName = WalkOfShameSound.REELS_LANDING.next();
        }

        const sound: NolimitHowl | undefined = this.soundPlayer.playTrack({
            name: soundName
        });
        this._prevReelStopSound = soundName;

        if (sound) {
            sound.player.stereo(WalkOfShameSound._davidPanningReelStop[reelId]);
        }
    }
}